import React from 'react'
import { Redirect } from 'react-router-dom';
import { Route, Switch } from 'react-router-dom';
import BatchList from '../Pages/batch';
import DatchDetails from '../Pages/batch/batchDetails';
import Dashboard from '../Pages/Dashboard';
import Login from '../Pages/login';
import ForgotPasswordverification from '../Pages/login/forgotPasswordverification';
import PasswordReset from '../Pages/login/passwordReset';
import PendingVerification from '../Pages/pending';
import ProductList from '../Pages/products';
import ProductDetails from '../Pages/products/productDetails';
import Registration from '../Pages/registration';
import Verification from '../Pages/registration/verification';
import Setting from '../Pages/setting';
import supportDetails from '../Pages/support/supportDetails';
import supportList from '../Pages/support/supportList';
import { Container } from '../styles/globalStyle';

const Switcher = () => {
    return ( 
        <Container style={{position: 'relative', top: '80px'}}>
            <Switch>
                
                <Route path="/login" exact component={Login} />
                <Route path="/registration-verification" exact component={Verification} />
                <Route path="/registration" exact component={Registration} />
                <Route path="/forgot-password" exact component={ForgotPasswordverification} />
                <Route path="/reset-password-verify" exact component={PasswordReset} />
                <Route path="/pending-verification" exact component={PendingVerification} />
              
                    <Route path="/dashboard" exact component={Dashboard} />
                    <Route path="/setting" exact component={Setting} />
                    <Route path="/product-list" exact component={ProductList} />
                    <Route path="/product-details" exact component={ProductDetails} />
                    <Route path="/batch-list" exact component={BatchList} />
                    <Route path="/batch-details" exact component={DatchDetails} />

                    <Route path="/support" exact component={supportList} />
                    <Route path="/ticket-details" exact component={supportDetails} />
               
                    <Redirect from='/' exact to="/dashboard" />
                
                    <Redirect to="/404" />
            </Switch>
            
        </Container>
     );
}

export default Switcher;